module.exports = __webpack_public_path__ + "img/E12.544f723f.svg";